import { createApp } from 'vue';
import { createPinia } from 'pinia';
import {
  DashboardLayout,
  NoneLayout,
} from '@/components/layout';

import i18n from '@/i18n';
import router from '@/router/index';
import App from '@/App.vue';
import vuetify from '@/plugins/vuetify';

import '@/assets/css/scss/main.scss';
import '@/assets/css/print.css';

const app = createApp(App);

app.component('DashboardLayout', DashboardLayout);
app.component('NoneLayout', NoneLayout);

app.use(router);
app.use(createPinia());
app.use(i18n);
app.use(vuetify);

app.config.errorHandler = (err, vm, info) => {
  console.error('Error:', err, vm, info);
};

app.mount('#app');
